module.exports = __webpack_public_path__ + "img/leads-active.17acec55.svg";